import { useToast } from '@repo/design-system/index'
import { useMemo } from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import FaceBookShareButton from '../../../components/common/buttons/FaceBookShareButton'
import KakaoShareButton from '../../../components/common/buttons/KakaoShareButton'
import { n_common, s_content } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'
import { ICON_SHARE_LINK, ICON_SHARE_PRIMARY } from '../../../modules/svg/svg'
import Button from '../../_legacy/Button'

interface SharingTooltipType {
  title?: string
  subtitle?: string
  imageUrl?: string
  webUrl?: string
  md?: boolean
  xs?: boolean
  sm?: boolean
  lg?: boolean
  primary?: boolean
  outlined?: boolean
  disabled?: boolean
  top?: number
  right?: number
  left?: number
  bottom?: number
  tooltipLocation?: SHARING_TOOLTIP_LOCATION
  contentsId?: string | string[]
  component?: any
  showTooltip?: boolean
  setShowToolTip?: any
}
export enum SHARING_TOOLTIP_LOCATION {
  PORTAL_MATERIAL,
}
const SharingTooltip = (props: SharingTooltipType) => {
  const {
    title,
    subtitle,
    imageUrl,
    tooltipLocation,
    webUrl,
    sm,
    xs,
    md,
    lg,
    primary,
    outlined,
    disabled,
    right,
    top,
    left,
    bottom,
    contentsId,
    component,
    showTooltip,
    setShowToolTip,
  } = props
  const { locale, t } = useTranslation()
  const { toastSuccess } = useToast()

  const handleFinishCopy = () => {
    toastSuccess(t(n_common.toast_link))
  }
  const domain = 'ringleplus.com'
  const serviceURL = `ringleplus.com/${locale}/student/landing/contents`
  const APP_DOWN_MESSAGE_CLICK_LINK = {
    LANDING_MATERIAL: `https://ringle.page.link/?link=https://${serviceURL}/material/${contentsId}&apn=com.ringle&ibi=org.reactjs.native.example.Ringle&isi=1189876556&efr=1`,
  }
  const appDeepLink = useMemo(() => {
    switch (tooltipLocation) {
      case SHARING_TOOLTIP_LOCATION.PORTAL_MATERIAL:
        return APP_DOWN_MESSAGE_CLICK_LINK.LANDING_MATERIAL
    }
  }, [tooltipLocation])

  return (
    <div className="relative">
      {component ? (
        <div className="flex items-center justify-center">{component}</div>
      ) : (
        <Button
          md={md}
          xs={xs}
          sm={sm}
          lg={lg}
          primary={primary}
          outlined={outlined}
          disabled={disabled}
          relative
          mxAuto
          onClick={() => setShowToolTip((prev) => !prev)}
        >
          <div className="flex flex-row justify-center">
            <div className="mr-[8px]">
              <img src={ICON_SHARE_PRIMARY} />
            </div>
            <div>{t(s_content.sharing)}</div>
          </div>
        </Button>
      )}
      {showTooltip && (
        <div
          style={{ top: `${top}px`, right: `${right}px`, left: `${left}px`, bottom: `${bottom}px` }}
          className="speech-bubble absolute right-[50%] z-[70] w-[256px] translate-x-2/4 rounded-[5px] bg-white shadow-md"
        >
          <div className="border-1 rounded-[5px] px-[10px] py-[24px]">
            <div className="flex flex-row items-center justify-center">
              <div className="flex flex-col items-center">
                <FaceBookShareButton linkUrl={`${locale}${webUrl}`} />
                <div className="mt-[4px] text-center text-[12px] text-gray-700">{t(s_content.facebook)}</div>
              </div>
              <div className="mx-[24px] flex flex-col items-center">
                <KakaoShareButton
                  title={title}
                  description={subtitle}
                  webUrl={appDeepLink}
                  mobileWebUrl={appDeepLink}
                  imageUrl={imageUrl}
                />
                <div className="mt-[4px] text-center text-[12px] text-gray-700">{t(s_content.kakakotalk)}</div>
              </div>
              <CopyToClipboard text={`https://www.${domain}/${locale}${webUrl}`} onCopy={() => handleFinishCopy()}>
                <div className="flex cursor-pointer flex-col items-center">
                  <img src={ICON_SHARE_LINK} className="w-[47px]" />
                  <div className="mt-[4px] text-center text-[12px] text-gray-700">{t(s_content.url_copy)}</div>
                </div>
              </CopyToClipboard>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default SharingTooltip
